import React from "react";

import { ColorSecondary, IgChip } from "@intelligems/ig-theme";
import { Box, Grid } from "@mui/material";

import { UpdatedKeyValueLine } from "./Update/UpdatedKeyValueLine";
import { StyledAccordion } from "./Accordion";
import { Event } from "./Event";
import { ObjectTitle } from "./ObjectTitle";
import { componentSort, KEYS_TO_IGNORE } from "./utils";

const ChipSx = {
  "& .MuiChip-label": {
    padding: "4px",
  },
  marginLeft: "2px",
  marginRight: "2px",
};

export const NestedObject = ({ value, k }: { value: any; k: string }) => {
  if (KEYS_TO_IGNORE.includes(k)) {
    return null;
  }

  const createdCount = Object.values(value).filter(
    (o: any) => o.type === "created"
  ).length;

  const updatedCount = Object.values(value).filter(
    (o: any) => o.type === "updated"
  ).length;

  const deletedCount = Object.values(value).filter(
    (o: any) => o.type === "deleted"
  ).length;

  return (
    <StyledAccordion
      title={
        <>
          <Box component={"span"} mr={"10px"}>
            <ObjectTitle data={value} k={k} action={"Updated"} />
          </Box>
          {createdCount ? (
            <IgChip
              sx={ChipSx}
              label={`+ ${createdCount}`}
              status={"success"}
            />
          ) : null}
          {updatedCount ? (
            <IgChip sx={ChipSx} label={`± ${updatedCount}`} status={"info"} />
          ) : null}
          {deletedCount ? (
            <IgChip sx={ChipSx} label={`- ${deletedCount}`} status={"error"} />
          ) : null}
        </>
      }
      defaultExpanded={false}
      color={ColorSecondary.main}
      content={
        <Grid container item direction={"column"} rowSpacing={1}>
          {Object.entries(value)
            .flatMap(([k, value], index) => {
              if (value && typeof value === "object") {
                return Event({ k, value, key: `${k}-${index}` });
              } else {
                return {
                  type: "default",
                  element: (
                    <UpdatedKeyValueLine
                      k={k}
                      value={value}
                      key={`${k}-${index}`}
                    />
                  ),
                };
              }
            })
            .sort(componentSort)
            .map((i) => i.element)}
        </Grid>
      }
    />
  );
};
